export function getCheckoutTotal (id) {
  const el = document.querySelector(`#${id}-form`);
  const data = el.dataset.cartTotal;

  return data ? JSON.parse(data) : {};
}
